export default "/kiban/_next/static/images/redIcon-6d56383842bc83a3f75418e8d923b818.png";